<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia/dist/pinia'
import { ValidationButton, ShipIndex } from '@haskoning/vue-component-library'

import { useShipStore } from '@/stores/ship'
import { useShipApiStore } from '@/stores/shipApi'
import ShipTableHeader from '@/components/import-ship/ShipTableHeader.vue'
import ShipAPITableRow from '@/components/import-ship/ShipAPITableRow.vue'

const emit = defineEmits(['close'])

const shipStore = useShipStore()
const shipApiStore = useShipApiStore()

const {
  currentItem,
  items: ships,
  validationStatus,
  fetchLoading: shipLoading,
  selectedItems,
  isAuth: shipApiIsAuth
} = storeToRefs(shipApiStore)
const { createLoading } = storeToRefs(shipStore)

async function saveShip() {
  await shipStore.addShip()
  emit('close')
  shipApiStore.removeSelectedItems()
}

const validation = computed({
  get() {
    return validationStatus.value
  },
  set(value) {
    shipApiStore.setValidationStatus(value)
    shipApiStore.fetchItems()
  }
})

const headers = [
  { title: '' },
  { title: 'Name' },
  { title: 'Capacity' },
  { title: 'Length overall [m]' },
  { title: 'Breadth/beam' },
  { title: 'Laden' },
  { title: 'Ballasted' },
  { title: 'Main desk' },
  { title: 'Forecastle' },
  { title: 'Poop' },
  { title: 'Aftward' },
  { title: 'Forward' },
  { title: 'Validation' }
]
</script>

<template>
  <v-card class="pa-3 fill-height overflow-y-auto">
    <v-card-title>
      Import ship
      <ValidationButton class="ml-2" v-model="validation" />
    </v-card-title>
    <v-alert
      v-if="!shipApiIsAuth"
      type="warning"
      variant="tonal"
      density="compact"
      class="mx-4 mb-3 flex-0-0"
    >
      Not connected to SHIP, so ships can't be loaded or imported. Reload the page to try again, or
      contact your administrator if this keeps happening.
    </v-alert>
    <ShipIndex
      :currentItem="currentItem"
      :items="ships"
      :selected-items="selectedItems"
      :loading="shipLoading"
      :check-all-disabled="!ships.length"
      desity="default"
      :headers="headers"
      :show-plan-view="true"
      @update-selected-items="shipApiStore.updateSelectedItems"
      height="88vh"
      class="mx-4"
    >
      <template v-slot:table-header>
        <ShipTableHeader />
      </template>
      <template v-slot:table-row="{ item }">
        <ShipAPITableRow :item="item"></ShipAPITableRow>
      </template>
    </ShipIndex>
    <v-card-actions class="mt-3 pb-0">
      <v-spacer></v-spacer>
      <v-btn
        variant="text"
        color="primary"
        :disabled="createLoading"
        class="text-none"
        @click="emit('close')"
      >
        Cancel
      </v-btn>
      <v-btn
        :loading="createLoading"
        :disabled="!selectedItems.length"
        variant="text"
        color="primary"
        @click="saveShip()"
        class="text-none"
      >
        Import from SHIP
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
